import { api_base } from '../api';
import { toast } from '../../scripts/toast';

export const Newsletter = {
	subscribe (email) {
		$.ajax({
			// set the email parameter.
			url: api_base + '/subscribe?email=' + email,
			method: 'GET',

			success: function (res) {
				return toast({
					title: 'Newsletter',
					content: 'Te has suscrito correctamente al newsletter, checa la bandeja de entrada de tu correo.'
				});
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}
				
				if (err.status == 422) {
					return toast({
						title: 'Newsletter',
						content: 'Este correo ya ha sido registrado'
					});
				}

				toast({
					title: 'Newsletter',
					content: 'Ingresa un correo valido.'
				});
				// console.log(err)
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/store/api/newsletter.js